import request from '@/utils/request'

const getCurrentUserTrainings = () => {
  return request({
    url: `${process.env.VUE_APP_ALIEXPRESS_API}/Training/GetCurrentUserTrainings`,
    method: 'get'
  })
}

const resetCurrentUserTraining = () => {
  return request({
    url: `${process.env.VUE_APP_ALIEXPRESS_API}/Training/ResetCurrentUserTraining`,
    method: 'post'
  })
} 

export default {
  getCurrentUserTrainings,
  resetCurrentUserTraining
}
